<template>
  <v-layout row justify-center>
    <v-dialog v-model="isVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="CloseDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Company settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn light flat @click="isVisible = false">Save</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-subheader>Notifications</v-subheader>
          <v-card flat>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-checkbox
                      v-model="company.notificationB24"
                      @change="UpdateNotificationConfig('B24')"
                      label="24 hours before"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-checkbox
                      v-model="company.notificationB2"
                      label="2 hours before"
                      @change="UpdateNotificationConfig('B2')"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4">
                    <v-checkbox
                      v-model="company.notificationB1"
                      label="1 hour before"
                      @change="UpdateNotificationConfig('B1')"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>

          <v-container>
            <v-row justify="space-around">
              <div v-for="(smstemplate, index) in smsTemplates" :key="index">
                <company-settings-card>
                  <template #title>{{ smstemplate.title }}</template>
                  <template #save>
                    <v-btn
                      :disabled="
                        !$v.smsTemplates.$each[index].text.$dirty ||
                          $v.smsTemplates.$each[index].text.$model === ''
                      "
                      color="white"
                      @click="SaveSmsTemplate($v.smsTemplates.$each[index])"
                    >
                      <v-icon color="primary">mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <template #templateText>
                    <v-textarea
                      outlined
                      background-color="white"
                      light
                      :maxlength="smsCharLength"
                      name="input-7-4"
                      v-model="$v.smsTemplates.$each[index].text.$model"
                      no-resize
                      :counter="smsCharLength"
                      @input="$v.smsTemplates.$each[index].text.$touch()"
                      :ref="smstemplate.type"
                    ></v-textarea>
                  </template>
                  <template #cardActions>
                    <v-btn
                      light
                      class="mb-3"
                      color="white"
                      @click="Insert(' {{USER}}', $v.smsTemplates.$each[index])"
                      >Name</v-btn
                    >
                    <v-btn
                      light
                      color="white"
                      @click="Insert(' {{STARTDATETIME}}', $v.smsTemplates.$each[index])"
                      >Date & time</v-btn
                    >
                  </template>
                  <template></template>
                </company-settings-card>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import companySettingsCard from '../main/CompanySettingsCard.vue';
import axios from 'axios';

export default {
  components: {
    companySettingsCard,
  },
  validations: {
    smsTemplates: {
      $each: {
        text: { required },
      },
    },
    notificationB24: {},
    notificationB2: {},
    notificationB1: {},
  },
  data() {
    return {
      isVisible: false,
      smsCharLength: 140,
      company: {
        notificationB24: true,
        notificationB2: false,
        notificationB1: false,
      },
      value: '',
      smsTemplates: [
        {
          type: 'smstemplate',
          title: 'Registration template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-secondary',
          title: 'Registration template - secondary language',
          text: '',
          errors: [],
        },
        {
          type: 'updatetemplate',
          title: 'Update template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'updatetemplate-secondary',
          title: 'Update template - secondary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-reminder',
          title: 'Reminder template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-reminder-secondary',
          title: 'Reminder template - secondary language',
          text: '',
          errors: [],
        },
      ],
    };
  },
  methods: {
    OpenDialog() {
      this.$v.$reset();
      this.GetCompanyConfigs();
      this.isVisible = true;
    },
    CloseDialog() {
      this.isVisible = false;
    },
    Insert(myvalue, template) {
      let control = this.$refs[template.$model.type][0].$el.querySelector('textarea');

      let controlTextValue = control.value;
      let cursorPos = control.selectionEnd;
      if (controlTextValue == null || controlTextValue === '') {
        controlTextValue = myvalue;
        return;
      }
      controlTextValue =
        controlTextValue.substring(0, cursorPos) + myvalue + controlTextValue.substring(cursorPos);
      cursorPos += controlTextValue.length;
      template.text.$model = controlTextValue;
    },
    GetCompanyConfigs() {
      let queryString = `query companyConfigs($id: String!){
          companyConfigs(id:$id) {
            configKey
            configValue
          }
        }`;

      axios
        .post('/graphql', {
          query: queryString,
          variables: { id: this.$store.getters.user.details.companyId },
        })
        .then((res) => {
          let configs = res.data.data.companyConfigs;
          configs.forEach((config) => {
            if (config && config.configKey) {
              if (
                config.configKey === 'smstemplate' ||
                config.configKey === 'smstemplate-secondary' ||
                config.configKey === 'updatetemplate' ||
                config.configKey === 'updatetemplate-secondary' ||
                config.configKey === 'smstemplate-reminder' ||
                config.configKey === 'smstemplate-reminder-secondary'
              ) {
                this.smsTemplates.find((conf) => conf.type == config.configKey).text =
                  config.configValue;
              } else if (config.configKey == '24 hours before') {
                this.company.notificationB24 = config.configValue == 'true';
              } else if (config.configKey == '2 hours before') {
                this.company.notificationB2 = config.configValue == 'true';
              } else if (config.configKey == '1 hour before') {
                this.company.notificationB1 = config.configValue == 'true';
              }
            }
          });
        })
        .catch(() => {
          this.showError('Could not get company configuration details!');
        });
    },

    SaveSmsTemplate(smstemplate) {
      smstemplate.text.$touch();
      if (smstemplate.text.$invalid) return;
      let type = smstemplate.$model.type;
      let companyID = this.$store.getters.user.details.companyId;
      var companyConfig = {
        companyConfig: {
          companyId: companyID,
          configKey: type,
          configValue: smstemplate.text.$model.trim(),
        },
      };
      let mutation = `
      mutation saveCompanyConfig($companyConfig: SaveCompanyConfig!) {
	      saveCompanyConfig(companyConfig: $companyConfig) {
          id
          }
        }`;
      axios
        .post('/graphql', {
          query: mutation,
          variables: companyConfig,
        })
        .then((res) => {
          if (res.data.data.saveCompanyConfig) {
            smstemplate.$reset();
            this.showSuccess('Template saved!');
          }
        })
        .catch((error) => {
          console.log(error);
          this.showError('Could not save company address');
        });
    },

    UpdateNotificationConfig(value) {
      let companyID = this.$store.getters.user.details.companyId;
      let configValue = null;
      let configKey = '';
      if (value == 'B24') {
        configKey = '24 hours before';
        configValue = this.company.notificationB24.toString();
      } else if (value == 'B2') {
        configKey = '2 hours before';
        configValue = this.company.notificationB2.toString();
      } else if (value == 'B1') {
        configKey = '1 hour before';
        configValue = this.company.notificationB1.toString();
      }

      var companyConfig = {
        companyConfig: {
          companyId: companyID,
          configKey: configKey,
          configValue: configValue,
        },
      };
      let mutation = `
      mutation saveCompanyConfig($companyConfig: SaveCompanyConfig!) {
	      saveCompanyConfig(companyConfig: $companyConfig) {
          id,
          configKey
          }
        }`;
      axios
        .post('/graphql', {
          query: mutation,
          variables: companyConfig,
        })
        .then((res) => {
          if (res.data.data.saveCompanyConfig) {
            this.showSuccess('Configuration saved!');
          }
        })
        .catch(() => {
          this.showError('Could not save configuration!');
        });
    },
  },
};
</script>

<style></style>
